module.exports = __webpack_public_path__ + "static/bg-sec3-6b27e48e3be2beab7f2e003a9d54986c.jpg";